import { datadogLogs } from '@datadog/browser-logs';

import {
    getItemFromStorage,
    removeItemFromStorage,
    setItemInStorage,
} from 'src/utils/storageUtils';

const DOMAIN_KEY = '__sso_direct_login_domain__';

export function setSsoDirectLoginDomain(auth0ConnectionName?: string) {
    if (auth0ConnectionName === undefined) {
        removeItemFromStorage(DOMAIN_KEY);
        return;
    }

    try {
        setItemInStorage(DOMAIN_KEY, auth0ConnectionName, { sessionStorageOnly: true });
    } catch (error: any) {
        datadogLogs.logger.warn(
            'Unable to set sso direct login sentinel in session storage',
            undefined,
            error
        );
    }
}

export function getSsoDirectLoginDomain(): string | null {
    return getItemFromStorage(DOMAIN_KEY, null, { sessionStorageOnly: true });
}
